import React from 'react'

const Minus: React.FC = () => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" width="20" height="20"><path fillRule="evenodd" d="M15.5,10 L15.5,11 L4.5,11 L4.5,10 L15.5,10 Z"></path></svg>
  )
}

export default Minus